import * as React from 'react'
import { Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useData } from './hooks'
import {
  addLeadNote,
  addNoteToPestPac,
  noteCode,
  serviceLocation,
} from '@user/components/Settings/EntityFormSettings/constants'
import Stack from '@mui/material/Stack'
import { NoteFormFieldElements } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/NoteFormElements'
import { NoteCode } from '@user/components/Notes/typings'
import Paper from '@mui/material/Paper'

type Props = {
  hideOptional: boolean
  variant: 'card' | 'standard'
  noteCodes: NoteCode[]
  hideTitle?: boolean
  fromMapView?: boolean
}

export function Note(props: Props) {
  const {
    hideOptional,
    variant,
    noteCodes,
    hideTitle = false,
    fromMapView = false,
  } = props

  const {
    errors,
    touched,
    requiredAddNote,
    showAddNote,
    values,
    setFieldValue,
  } = useData({
    hideOptional,
  })

  const externalId = values.externalLocationId

  function getContent() {
    return (
      <Stack direction="column" width="100%">
        {!hideTitle && (
          <Typography variant="h6" mb={1}>
            Note
          </Typography>
        )}

        <NoteFormFieldElements
          fromMapView={fromMapView}
          serviceOptions={
            values.externalLocationId
              ? [
                  {
                    value: values.serviceLocation || '',
                    label: values.serviceLocation || '',
                  },
                ]
              : []
          }
          noteCodes={noteCodes}
          externalLocationId={externalId}
          maxNoteLines={externalId ? 5 : 10}
          noteFieldName={addLeadNote}
          noteFieldHelp={
            errors[addLeadNote] && touched[addLeadNote]
              ? errors[addLeadNote]
              : `${
                  values[addLeadNote]
                    ? values[addLeadNote]?.length?.toLocaleString()
                    : 0
                }/5,000`
          }
          noteFieldError={errors[addLeadNote] && touched[addLeadNote]}
          toggleName={addNoteToPestPac}
          toggleValue={values[addNoteToPestPac]}
          requiredAddNote={requiredAddNote}
          requiredOtherFields={Boolean(values[addLeadNote])}
          serviceLocationHelp={
            errors[serviceLocation] && touched[serviceLocation]
              ? errors[serviceLocation]
              : ''
          }
          serviceLocationError={
            errors[serviceLocation] && touched[serviceLocation]
          }
          noteCodeFieldName={noteCode}
          noteCodeHelp={
            errors[noteCode] && touched[noteCode] ? errors[noteCode] : ''
          }
          noteCodeError={errors[noteCode] && touched[noteCode]}
          selectWidth={!hideTitle ? '100%' : undefined}
          toggleVMargin={3}
          serviceLocationFieldName={serviceLocation}
          noteCode={values.noteCode}
          setFieldValue={setFieldValue}
          serviceLocation={values.serviceLocation}
        />
      </Stack>
    )
  }

  return showAddNote ? (
    variant === 'card' ? (
      <Paper
        elevation={0}
        sx={{
          padding: (theme: Theme) => theme.spacing(2),
          paddingBottom: (theme: Theme) => theme.spacing(1),
          border: 'solid 1px #e0e0e0',
        }}
      >
        {getContent()}
      </Paper>
    ) : (
      <>{getContent()}</>
    )
  ) : null
}
